var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Topic = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
const get_topic_info_1 = require("../../lib/get-topic-info");
const topic_body_1 = require("./topic-body");
exports.Topic = (props) => {
    if (!props.topic) {
        return null;
    }
    const topicInfo = get_topic_info_1.getTopicInfo(props.topic);
    const fullTopicAsLink = !props.topicOptions.hideAction &&
        topicInfo.hasAction &&
        props.fullTopicAsLink;
    const action = props.topic.actions && props.topic.actions[0];
    let Element;
    let elementProps;
    let elementNcssVariable;
    if (fullTopicAsLink) {
        Element = core_1.Action;
        elementProps = Object.assign(Object.assign({}, action), { icon: undefined });
        elementNcssVariable = 'containerAsLink';
    }
    else {
        Element = core_1.Box;
        elementProps = { is: 'div' };
        elementNcssVariable = 'container';
    }
    return (react_1.default.createElement(Element, Object.assign({}, elementProps, { wheel: Object.assign(Object.assign({}, props.wheel), { style: core_1.getNcssSwitch(props.wheel.style, elementNcssVariable) }) }),
        react_1.default.createElement(topic_body_1.TopicBody, Object.assign({}, props))));
};
//# sourceMappingURL=topic.js.map